import React, {useEffect, useState} from "react";

import './styles/result.scss';

import Status from "./Status";
import DetailSection from "./DetailSection";
import FibreConnectStatus from "./FibreConnect/FibreConnectStatus";
import UnidataStatus from "./Unidata/UnidataStatus";

import DownArrowIcon from '../img/down.png';
import UpArrowIcon from '../img/up.png';
import RulerIcon from '../img/ruler.png';

const Result = (props) => {
    const data = props.data;
    const FC = data.FC;
    const OF = data.OF;

    const [bestProfile, setBestProfile] = useState({maxUp: "N.D.", maxDow: "N.D.", distance: "N.D.", FTTH: false, fiberMaxSpeed: '0'})

    useEffect(() => {
        let maxUp = 0, maxDow = 0, distance, fiberMaxSpeed = '0', FTTH = false;

        try{
            if(FC['COPERTURA_BITSTREAM_NGA_VULA_XGSPON'] === 'Attivo'){
                fiberMaxSpeed = '10 Gbit'
                FTTH = true
            }
            else if(FC["COPERTURA_BITSTREAM_NGA_VULA_FTTH"] === "Attivo") {
                maxDow = 1000
                maxUp = 200
                fiberMaxSpeed = '2.5 Gbit'
                FTTH = true;
            }
            else{
                for (let [key, value] of Object.entries(FC)) {
                    if(key.search("DOWN") !== -1) {
                        if(FC[key.replace("VELOCITA_DOWN","COPERTURA")] !== "NO" && (Number(FC[key]) > maxDow)) {
                            maxDow = value;
                        }
                    }
                    if(key.search("UP") !== -1) {
                        if(FC[key.replace("VELOCITA_UP","COPERTURA")] !== "NO" && (Number(FC[key]) > maxUp)) {
                            maxUp = value;
                        }
                    }
                }
            }
    
            
            maxUp = Math.floor(maxUp)
            maxDow = Math.floor(maxDow);
            if(FC.DISTANZA_BITSTREAM_NGA_VULA_FTTCab !== "N.D.") distance = Math.floor(FC.DISTANZA_BITSTREAM_NGA_VULA_FTTCab)
            else distance = "N.D."
            if(maxDow + maxUp === 0) {
                maxUp = "N.D." 
                maxDow = "N.D."
            }
    
        }catch(e){
    
            maxUp = "N.D."
            maxDow = "N.D"
            distance = "N.D."
        }

        setBestProfile({maxDow, maxUp, distance, fiberMaxSpeed, FTTH})
    }, [FC])


    const setStatus = (rows, provider, err) => {
        if(provider === 'of'){
            if(rows.status === 'city_connected') return <Status option="city_connected_of"/>
            else if (data.status === 'city_connected' && rows.of.length === 0) return <Status option="city_not_connected_of"/> 
            else if(rows.status === 'something_missing') return <Status option="something_missing" error={OF.code}/>
            else if(rows.status === 'pac/pal') return <Status option='pac/pal' />
            else if(rows.of.length > 0) return <Status option="civic_connected_of"/>
            else return <Status option="civic_not_connected_of"/>

        } 
        else if(provider === 'fc'){
            if(bestProfile.distance === 100000 ) return (
                <div style={{width: '90%', backgroundColor: 'white', paddingTop: '10px',borderRadius: '14px', color: 'black', minHeight: '200px'}}>
                    <Status option="civic_not_connected_fc" />
                </div>
            )
        }
        return;
    }    

    return(
        <div className="resultSection" style={{backgroundColor: '#ff0f64', borderRadius: '14px', color: 'white', width: '90%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: 'auto',transform: 'scale(0.95)'}}>
            <h1 style={{fontSize: '2.5rem', margin: '5px', fontWeight:'bold'}}>Fibercop</h1>
            {(data.status === 'city_connected') && <Status option='city_connected'/> } 
            {(data.status !== 'city_connected') && <div style={{width: '100%'}}>
                {!bestProfile.FTTH ? 
                    <div className="fcBorder">
                    <h2 style={{color:'white', marginLeft: '10px', marginTop: '0px', fontWeight: '500'}} >Miglior profilo</h2>
                        <div className="fcSection">
                            <div style={{textAlign: 'center'}}>
                                <img src={DownArrowIcon} alt="down" style={{filter: 'invert(1)'}}/>
                                <p>DOWNLOAD</p>
                                {bestProfile.maxDow}
                                <p>Mbps</p>
                            </div>
                            <div style={{textAlign: 'center'}}>
                                <img src={UpArrowIcon} alt="up" style={{filter: 'invert(1)'}}/>
                                <p>UPLOAD</p>
                                {bestProfile.maxUp}
                                <p>Mbps</p>
                            </div>                    
                            <div style={{textAlign: 'center'}}>
                                 <img src={RulerIcon} alt="ruler" style={{filter: 'invert(1)'}}/>
                                <p>DISTANZA </p>
                                {bestProfile.distance}
                                <p>metri</p>
                            </div>
                        </div> 
                    </div>
                        :   
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'white', width: '90%', margin:'auto', borderRadius: '14px', marginBottom: '20px', marginTop: '0', paddingBottom: '10px'}}>
                        <h2 style={{color:'grey', margin: '0 auto 10px 10px'}} >Miglior profilo</h2>
                        <p style={{color: 'black', fontSize: '30px', margin: '0', fontWeight: 'bold'}}>FTTH <span style={{backgroundColor: '#2ecc71', color: 'white', fontWeight: 'bold', borderRadius: '10px', padding: '0 10px 0 10px'}}>{bestProfile.fiberMaxSpeed}</span></p>
                    </div>
                }
                <div style={{width: 'calc(90% - 20px)', backgroundColor: 'white', borderRadius: '14px', margin: 'auto', color: 'black',padding: '10px'}}>
                    <DetailSection data={FC}/>
                </div>

            </div>}
            <h2 style={{fontSize: '2.5rem', margin: '5px', fontWeight:'bold'}}>OpenFiber</h2>
            <div style={{width: '90%', backgroundColor: 'white', paddingTop: '10px',borderRadius: '14px', color: 'black', minHeight: '200px'}}>
                {setStatus(OF, 'of')}
            </div>
            <h2 style={{fontSize: '2.5rem', margin: '5px', fontWeight:'bold'}}>FibreConnect</h2>
            <div style={{width: '90%', backgroundColor: 'white', paddingTop: '10px',borderRadius: '14px', color: 'black', minHeight: '200px'}}>
                {FibreConnectStatus(data.status, data.FIBRE.is_connected)}
            </div>
            <h2 style={{fontSize: '2.5rem', margin: '5px', fontWeight:'bold'}}>Unidata</h2>
            <div style={{width: '90%', backgroundColor: 'white', paddingTop: '10px',borderRadius: '14px', color: 'black', minHeight: '200px'}}>
                {UnidataStatus(data.status, data.UNI.is_connected)} 
            </div>
        </div>
    )
}

export default Result;